import React from "react";

export function DashboardViewer({

}) {
  return <div>Dashboard</div>
}